<template>
<b-modal ref="modal" hide-footer hide-header centered :modal-class="theme">
		<AddressForm ref="addressForm" />
		<div class="d-flex align-items-center justify-content-end mt-5">
			<button class="btn btn-secondary mr-3" @click="hide">Cancel</button>
			<button class="btn btn-primary" @click="saveAddress">
				<span
					v-if="loading"
					class="spinner-border spinner-border-sm"
					role="status"
					aria-hidden="true"
				></span>
				Save
			</button>
		</div>
		<ErrorDialog ref="errDialog" />
	</b-modal>
</template>

<script>
import AddressForm from "./AddressForm";
import ErrorDialog from "../shared/ErrorDialog";
import CardService from "../../services/card";
import ThemeService from "../../services/theme";

export default {
	name: "AddressAddDialog",
	components: {
		AddressForm,
		ErrorDialog,
	},
	data() {
		return {
			loading: false,
			theme: 'light'
		};
	},
	created() {
		this.theme = ThemeService.instance().getTheme() || 'light';
		this.listenForThemeChanges();
	},
	methods: {
		show: function () {
			this.$refs["modal"].show();
		},
		hide: function () {
			this.$refs["modal"].hide();
		},
		saveAddress: function () {
			let address = this.$refs.addressForm.getAddress();
			if (!address) return;
			this.loading = true;
			CardService.instance()
				.createAddress(address)
				.then(() => {
					this.loading = false;
					this.$emit("addressadded");
					this.hide();
				})
				.catch((err) => {
					this.loading = false;
					this.$refs.errDialog.show(err);
				});
		},
		listenForThemeChanges: function () {
			ThemeService.instance().events.on("themechanged", () => {
				this.theme = ThemeService.instance().getTheme();
			});
		},
	},
};
</script>

<style>
</style>